import { useMediaQuery } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import Timeline from '@material-ui/lab/Timeline';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import moment from 'moment';
import React, { Fragment } from 'react';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: '6px 16px'
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  },
  timelineContent: {
    padding: '12px 16px',
    margin: 'auto'
  },
  verticallyCenterContent: {
    margin: 'auto 0'
    // width: '200px',
    // flex: 'none' // Opcional: ajusta el ancho de la sección opuesta
  },

  //   timelineOppositeContent: {
  //     textAlign: 'right', // Alinea el contenido opuesto a la izquierda
  //     flex: 0.5 // Opcional: ajusta el ancho de la sección opuesta
  //   },
  //   timelineContent: {
  //     textAlign: 'left' // Alinea el contenido principal a la izquierda
  //   },
  timelineItem: {
    '&::before': {
      display: 'none' // Elimina la línea de tiempo predeterminada en el lado izquierdo
    }
  }
}));

const estados = {
  '1': {
    titulo: 'Envío por parte de la empresa',
    subtitulo: 'EXPORTADOR'
  },
  '2': {
    titulo: 'Admisión',
    subtitulo: 'DINACOPA - Admisión'
  },
  '3': {
    titulo: 'Transmisión a DNIT',
    subtitulo: 'DINACOPA - Operaciones'
  },
  '4': {
    titulo: 'Despacho',
    subtitulo: 'DINACOPA - Logística'
  }
};

const sortFunction = (a, b) => {
  if (a.id > b.id) {
    return 1;
  }
  if (a.id < b.id) {
    return -1;
  }
  return 0;
};

function uniqByKeepLast(a, key) {
  return [...new Map(a.map(x => [key(x), x])).values()];
}

const getFecha = item => {
  return moment(item.fecha, 'DD/MM/YYYY, HH:mm:ss').format(
    'DD/MM/YYYY, HH:mm:ss'
  );
};

const ItemFinal = ({ finalizado, isPhone, classes }) => {
  return (
    <TimelineItem className={classes.timelineItem}>
      {!isPhone && (
        <TimelineOppositeContent
          color="textSecondary"
          className={classes.verticallyCenterContent}
        />
      )}
      <TimelineSeparator style={{ marginLeft: isPhone ? 6 : 0 }}>
        {finalizado ? (
          <>
            <TimelineConnector className={classes.secondaryTail} />
            <TimelineDot color="secondary">
              <CheckIcon style={{ fontSize: 12 }} />
            </TimelineDot>
          </>
        ) : (
          <>
            <TimelineConnector />
            <TimelineDot />
          </>
        )}
        <TimelineConnector style={{ visibility: 'hidden' }} />
      </TimelineSeparator>
      <TimelineContent className={classes.timelineContent}>
        {finalizado ? (
          <Typography variant="h5" component="h1">
            Proceso finalizado
          </Typography>
        ) : (
          <Typography color="textSecondary">Proceso finalizado</Typography>
        )}
      </TimelineContent>
    </TimelineItem>
  );
};

const ItemConfirmado = ({
  id,
  primary,
  secondary,
  description,
  oposite,
  isPhone,
  classes
}) => {
  return (
    <TimelineItem key={id} className={classes.timelineItem}>
      {!isPhone && (
        <TimelineOppositeContent
          color="textSecondary"
          className={classes.verticallyCenterContent}
        >
          <Typography color="textSecondary">{oposite}</Typography>
        </TimelineOppositeContent>
      )}
      <TimelineSeparator>
        <TimelineConnector className={classes.secondaryTail} />
        <TimelineDot color="secondary">
          <CheckIcon style={{ fontSize: 12 }} />
        </TimelineDot>
        <TimelineConnector className={classes.secondaryTail} />
      </TimelineSeparator>
      <TimelineContent className={classes.timelineContent}>
        {isPhone && <Typography color="textSecondary">{oposite}</Typography>}
        <Typography>{primary}</Typography>
        {secondary && (
          <Typography color="textSecondary">{secondary}</Typography>
        )}
        {description && (
          <Typography variant="caption" color="textSecondary" gutterBottom>
            {description}
          </Typography>
        )}
      </TimelineContent>
    </TimelineItem>
  );
};

const ItemActual = ({
  id,
  primary,
  secondary,
  description,
  isPhone,
  classes
}) => {
  return (
    <TimelineItem key={id} className={classes.timelineItem}>
      {!isPhone && (
        <TimelineOppositeContent
          color="textSecondary"
          className={classes.verticallyCenterContent}
        >
          <Typography color="textSecondary">Pendiente</Typography>
        </TimelineOppositeContent>
      )}
      <TimelineSeparator style={{ marginLeft: isPhone ? 6 : 0 }}>
        <TimelineConnector className={classes.secondaryTail} />
        <TimelineDot variant="outlined" color="secondary" />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent className={classes.timelineContent}>
        {isPhone && <Typography color="textSecondary">Pendiente</Typography>}
        <Typography variant="h6" component="h1">
          {primary}
        </Typography>
        {secondary && (
          <Typography color="textSecondary">{secondary}</Typography>
        )}
        {description && (
          <Typography variant="caption" color="textSecondary" gutterBottom>
            {description}
          </Typography>
        )}
      </TimelineContent>
    </TimelineItem>
  );
};

const ItemSiguiente = ({ primary, description, isPhone, classes }) => (
  <TimelineItem className={classes.timelineItem}>
    {!isPhone && (
      <TimelineOppositeContent
        color="textSecondary"
        className={classes.verticallyCenterContent}
      />
    )}
    <TimelineSeparator style={{ marginLeft: isPhone ? 6 : 0 }}>
      <TimelineConnector />
      <TimelineDot />
      <TimelineConnector />
    </TimelineSeparator>
    <TimelineContent className={classes.timelineContent}>
      <Typography color="textSecondary">{primary}</Typography>
      {description && (
        <Typography variant="caption" color="textSecondary" gutterBottom>
          {description}
        </Typography>
      )}
    </TimelineContent>
  </TimelineItem>
);

export default function EstadosView({
  eventos,
  codigoTees,
  nroGuia,
  codigoDespacho
}) {
  const classes = useStyles();
  const theme = useTheme();

  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));

  const eventosResumen = uniqByKeepLast(
    eventos
      .sort(sortFunction)
      .filter(
        item =>
          estados[item.destino] &&
          item.destino !== 'ESTADO_REINTENTAR' &&
          item.destino !== 'ESTADO_VERIFICAR'
      ),
    it => it.destino
  );
  console.log('eventos', eventosResumen);

  return (
    <>
      <Timeline align="left" style={{ paddingLeft: 0, paddingRight: 0 }}>
        {eventosResumen &&
          Object.entries(estados).map(([key, value], index) => {
            const item = eventosResumen.find(
              evento => `${evento.destino}` === `${key}`
            );
            const size = eventosResumen.length;
            let component;

            if (item && item.fecha) {
              let secondary;

              if (item && `${item.destino}` === '2' && nroGuia) {
                secondary = `Guía: ${nroGuia || ''}`;
              }
              if (item && `${item.destino}` === '3' && codigoTees) {
                secondary = `TEES: ${codigoTees || ''}`;
              }
              if (item && `${item.destino}` === '4' && codigoDespacho) {
                secondary = `Despacho: ${codigoDespacho || ''}`;
              }

              component = (
                <ItemConfirmado
                  id={item.id}
                  oposite={getFecha(item)}
                  primary={estados[item.destino].titulo}
                  secondary={secondary}
                  description={estados[item.destino].subtitulo}
                  isPhone={isPhone}
                  classes={classes}
                />
              );
            } else if (item && index === size - 1) {
              component = (
                <ItemActual
                  id={item.id}
                  primary={estados[item.destino].titulo}
                  description={estados[item.destino].subtitulo}
                  isPhone={isPhone}
                  classes={classes}
                />
              );
            } else {
              component = (
                <ItemSiguiente
                  primary={value.titulo}
                  description={value.subtitulo}
                  isPhone={isPhone}
                  classes={classes}
                />
              );
            }
            return <Fragment key={key}>{component}</Fragment>;
          })}
        <ItemFinal
          finalizado={eventosResumen.some(
            item => `${item.destino}` === '4' && codigoDespacho
          )}
          isPhone={isPhone}
          classes={classes}
        />
      </Timeline>
    </>
  );
}
